import { useParams } from 'react-router-dom'
import UtilityProgramMultiProgramLearnMoreCard from './UtilityProgramMultiProgramLearnMoreCard'
import UtilityProgramLegacyLearnMoreCard from './UtilityProgramLegacyLearnMoreCard'
import { useDeviceProgramCategories } from '@/app/components/ProgramCards/DeviceProgramCards'
import { deviceTypeFromUrlSlug } from '@/app/components/DeviceSelectionGallery/DeviceSelectionGallery.utils'
import { DeviceUrlSlug } from '@/app/components/DeviceSelectionGallery/DeviceSelectionGallery.types'

type PathParams = {
  deviceId?: string
  deviceType?: DeviceUrlSlug
}

export default function UtilityProgramLearnMoreDashboardView() {
  const { deviceId, deviceType } = useParams<PathParams>()

  const {
    availablePrograms: multiProgramOnlyPrograms,
    isLoading: isLoadingMultiProgramOnlyPrograms,
  } = useDeviceProgramCategories(
    deviceId ? parseInt(deviceId) : undefined,
    deviceType ? deviceTypeFromUrlSlug(deviceType) : 'home',
    { multiProgramOnly: true },
  )

  if (isLoadingMultiProgramOnlyPrograms) {
    // Do not show any programs until multi-programs have loaded
    return null
  }

  if (multiProgramOnlyPrograms.length > 0) {
    return (
      <UtilityProgramMultiProgramLearnMoreCard
        availablePrograms={multiProgramOnlyPrograms}
      />
    )
  }

  return <UtilityProgramLegacyLearnMoreCard />
}
